import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import SaveEditFilterModel from './SaveEditFilterModel';

const SaveAsOrUpdateModel = ({ show, onHide, onSaveAs, onUpdate, isUpdating }) => {
  const [showSaveAsModal, setShowSaveAsModal] = useState(false);

  const handleUpdate = async () => {
    await onUpdate();
  };

  const handleSaveAs = async ({ viewName, setAsDefault }) => {
    await onSaveAs({ viewName, setAsDefault });
    setShowSaveAsModal(false);
    onHide();
  };

  const handleClose = () => {
    if (!isUpdating) {
      onHide();
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" style={{ zIndex: '99999' }}>
        <Modal.Header>
          <Modal.Title>
            <h6 className="mb-0 text-dark font-weight-bold">Save As or Update Confirmation</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">Do you want to update the current filter or save as a new filter?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isUpdating}>
            Cancel
          </Button>
          <Button variant="success" onClick={() => setShowSaveAsModal(true)} disabled={isUpdating}>
            Save As New
          </Button>
          <Button
            variant="primary"
            className="d-inline-flex align-items-center justify-content-center"
            style={{
              backgroundColor: '#FACC14',
              borderColor: '#FACC14'
            }}
            onClick={handleUpdate}
            disabled={isUpdating}
          >
            {isUpdating && <Spinner size="sm" animation="border" className="mr-1" />}
            {isUpdating ? 'Updating...' : 'Update View'}
          </Button>
        </Modal.Footer>
      </Modal>

      <SaveEditFilterModel
        show={showSaveAsModal}
        onHide={() => setShowSaveAsModal(false)}
        onSave={handleSaveAs}
        isUpdating={isUpdating}
      />
    </>
  );
};

export default SaveAsOrUpdateModel;
